import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs, IconButton, Button, Dialog, DialogTitle, DialogContent,
    DialogActions, TextField,Snackbar, Alert, Card,useMediaQuery , Typography , Grid } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import dayjs from 'dayjs';
import axiosInstance from '../axiosConfig';
import { useTheme } from '@mui/material/styles';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";



export default function Deliveries() {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box padding="1rem" mt={4}>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                sx={{
                    '& .MuiTabs-flexContainer': {
                        justifyContent: 'flex-start',
                        overflowX: 'auto',
                        paddingLeft: '0.5rem'
                    },
                    backgroundColor: '#f5f5f5'
                }}
            >
                <Tab label="Customer Daily Orders" />

            </Tabs>
            {tabValue === 0 && <CustomerDailyOrders />}

        </Box>
    );
}

function CustomerDailyOrders() {
    const [dailyOrders, setDailyOrders] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Fetch deliveries by selected date
    const fetchDeliveriesByDate = (date) => {
        const formattedDate = date.format('dddd'); // or format('YYYY-MM-DD') if your backend accepts full date
        axiosInstance
            .get(`/preorderbox/customer/deliveries?dayOfWeek=${formattedDate}`)
            .then((response) => {
                setDailyOrders(response.data);
                setPage(0);
            })
            .catch((error) => {
                console.error('Error fetching deliveries:', error);
            });
    };

    // Initial fetch for today on component mount
    useEffect(() => {
        fetchDeliveriesByDate(selectedDate);
    }, []);

    const handleDateChange = (newDate) => {
        if (newDate) {
            setSelectedDate(newDate);
            fetchDeliveriesByDate(newDate);
        }
    };

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
        setPage(0);
    };

    // Filter based on search text
    const filteredOrders = dailyOrders.filter(order =>
        order.customerName.toLowerCase().includes(filterText.toLowerCase())
    );

    // CSV export helper
    const exportToCSV = (data) => {
        const headers = ['Customer Name', 'Phone', 'Pickup / Delivery', 'Meal Type', 'Day of the Week'];
        const csvRows = [
            headers.join(','),
            ...data.map(order =>
                [
                    `"${order.customerName}"`,
                    `"${order.phone}"`,
                    `"${order.pickupLocation}"`,
                    `"${order.mealType}"`,
                    `"${order.dayOfWeek}"`
                ].join(',')
            )
        ];
        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `CustomerDailyOrders_${selectedDate.format('YYYY-MM-DD')}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    return (
        <Card sx={{ padding: '1rem', marginTop: '1rem', border: '1px solid #ccc' }}>
            <Grid container spacing={2} alignItems="center" mb={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Delivery Date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        label="Search"
                        value={filterText}
                        onChange={handleFilterChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => exportToCSV(filteredOrders)}
                        sx={{ height: '40px' }}
                    >
                        Export to CSV
                    </Button>
                </Grid>
            </Grid>

            {isMobile ? (
                <Box>
                    {filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order, index) => (
                        <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {order.customerName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {order.pickupLocation}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>
                                Meal Type: {order.mealType}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            ) : (
                <TableContainer sx={{ minWidth: 600 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Customer Name</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Pick Up / Delivery</TableCell>
                                <TableCell>Meal Type</TableCell>
                                <TableCell>Day of the Week</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order, index) => (
                                <TableRow key={index}>
                                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                    <TableCell>{order.customerName}</TableCell>
                                    <TableCell>{order.phone}</TableCell>
                                    <TableCell>{order.pickupLocation}</TableCell>
                                    <TableCell>{order.mealType}</TableCell>
                                    <TableCell>{order.dayOfWeek}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredOrders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            />
        </Card>
    );
}
